export default "__VITE_ASSET__DXzROUZs__"